import { render, staticRenderFns } from "./transferAdj.vue?vue&type=template&id=556922fc"
import script from "./transferAdj.vue?vue&type=script&lang=js"
export * from "./transferAdj.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports